import { Line, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

//https://www.digitalocean.com/community/tutorials/vuejs-vue-chart-js

export default {
  extends: Line,
  mixins: [reactiveProp],
  mounted () {
    if (this.chartData) {
    // this.chartData is created in the mixin
    this.renderChart(this.chartData, {
        scaleFontFamily: "'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif",
        scaleFontColor: '#999',
        scaleFontStyle: '600',
        tooltipTitleFontFamily: "'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif",
        tooltipCornerRadius: 3,
        maintainAspectRatio: false,
        responsive: true,
        maxHeight: '100',
        animation:false,
        legend: {
            display: false
         },
        scales:{
                xAxes: [{
                  stacked: true
                      }],
                yAxes: [{
                  ticks: {
                    beginAtZero : true
                  },
                  stacked: false,
                  type: 'linear',
                  position: 'left',
                  id: "y-axis-0",
                  },
                ]
              }
      })
    }
  }
}




// WEBPACK FOOTER //
// ./src/components/LineChart.js